module.exports = __webpack_public_path__ + "static/media/Desert Warrior.4dc455d2.jpg";